export const TeamMemberModule = {
    namespaced: true,
    state: {
        loadTeamMemberData: 1,
        TeamMemberList: [],
        TeamMemberFilterList: [],
        TeamMemberImgFilterList: []
    }
}